import React, { useState, useEffect } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { showInterestInVote, getUserDetails } from '../apis/apis';
import { useSnackbar } from '../../context/SnackbarContext';
import {
  setDashboardTab,
  setUserAuth,
  setUserAuthToken,
  setVoteDetailLocalStorage,
  setVoteOptionLocalStorage,
  getVoteDetailLocalStorage,
  getVoteStatusLocalStorage
} from '../../utils/LocalStorageUtils';
import { setPartner_Id } from "../../utils/LocalStorageUtils"
import VotingDrawer from './voting/VotingDrawer';
import { getPartner_Id } from '../../utils/LocalStorageUtils';
import { fetchPartnerIdFromApi } from '../../utils/FetchLogo';
import '../css/Sidebar.css';

const Vote = () => {
  const ERROR = '-1';
  const [logo, setLogo] = useState(null);
  const [open, setOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [selectedVoteId, setSelectedVoteId] = useState(null);
  const [logoError, setLogoError] = useState(null);
  const [showSuccessDialog, setShowSuccessDialog] = useState(false);
  const [partnerId, setPartnerId] = useState(getPartner_Id());

  const history = useHistory();
  const { showSnackbar } = useSnackbar();
  const { id } = useParams();
  const [status, setStatus] = useState("");
  const [loginEnabled, setLoginEnables] = useState(0);

  useEffect(() => {
  if (showSuccessDialog) {
    const timer = setTimeout(() => {
      if (loginEnabled === 1) {
        history.push("/user/home");
      }
    }, 2000); // 2 seconds delay

    return () => clearTimeout(timer); // cleanup if unmounted early
  }
}, [showSuccessDialog, loginEnabled, history]);

  useEffect(() => {
    localStorage.clear();
    showInterestInVote(id)
      .then((res) => {
        if (res.status) {
          setIsLoading(false);
          setDashboardTab(4);
          setUserAuthToken(id);
          setUserAuth(true);
          setVoteDetailLocalStorage(res.data.voteDetail);
          setVoteOptionLocalStorage(res.data.voteOptionList);
          getUserDetails()
            .then((result) => {
                setOpen(true);
                const storedVotes = getVoteDetailLocalStorage();
                if (storedVotes?.voteRid) {
                  setSelectedVoteId(storedVotes.voteRid);
                }
                if(result.data.loginEnabled === 1) {
                  setLoginEnables(1);
                }
            })
        } else {
          showSnackbar(res.description);
        }
      })
      .catch((e) => {
        showSnackbar(String(e));
      });
  }, [id, history, showSnackbar]);

  const handleClose = () => {
      setOpen(false);
      setShowSuccessDialog(true);
      setVoteDetailLocalStorage(null);
      if(loginEnabled === 0) {
        setDashboardTab(null);
      setUserAuthToken(null);
      setUserAuth(false);
      setVoteOptionLocalStorage(null);
      }
    }

  // const fetchLogo = (partnerId) => {
  //   return `${process.env.REACT_APP_BASE_URL}/logo/${partnerId}`;
  // };

  useEffect(() => {
    if (!partnerId) {
      fetchPartnerIdFromApi(
        setPartnerId,
        setPartner_Id,
        showSnackbar
      );
   //   setLogo(fetchLogo(partnerId));
    } else {
   //   setLogo(fetchLogo(partnerId));
    //  setLogoError(null);
    }
  }, [partnerId]);

  useEffect(() => {
    const storedStatus = getVoteStatusLocalStorage();
    if (storedStatus) {
      setStatus(storedStatus);
    }
  }, [open]);

  return isLoading ? (
    <div className="preview-loader-wrapper">
      <img className="logo" src={'/assets/logo.svg'} alt={'logo'} style={{ cursor: 'pointer', width: '130px', height: '50px' }}/>
    </div>
  ) : (
    <div>
      <div className="d-flex align-items-center py-4 px-5 border-bottom">
        <div className="d-flex gap-5 align-items-center flex-grow-1">
          <img
            src={'/assets/logo.svg'}
            alt={"logo"}
            className="img-logo"
            onClick={() => history.push("/user/home")}
          />
        </div>
      </div>
      {showSuccessDialog && (
        <div className="d-flex flex-column min-vh-100 justify-content-center align-items-center text-center h-100">
          <div className="container mx-auto">
            <h2 className="fw-bold"> {status==="Pending"
              ? "Your vote has been recorded successfully!"
              : "Your vote has been modified successfully!"}
            </h2>
          </div>
        </div>
      )}
      <VotingDrawer open={open} closeAction={handleClose} selectedVoteId={selectedVoteId} setCrossButton="false" />
    </div>

  );
};

export default Vote;